import { SourcesDictionaryItem } from 'src/app/apiAndObjects/objects/dictionaries/sourcesDictionaryItem';

export class ResultSourceItem {
  private _totalCount = 0;
  private _filterCount = 0;
  private _selected = true;

  constructor(private readonly dictItem: SourcesDictionaryItem) {}

  get id(): string {
    return this.dictItem.id;
  }
  get name(): string {
    return this.dictItem.name;
  }
  set totalCount(count: number) {
    this._totalCount = count;
  }
  get totalCount(): number {
    return this._totalCount;
  }
  set filterCount(count: number) {
    this._filterCount = count;
  }
  get filterCount(): number {
    return this._filterCount;
  }
  set selected(selected: boolean) {
    this._selected = selected;
  }
  get selected(): boolean {
    return this._selected;
  }
}
